import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgUserIconSecondary from './svgs/UserIconSecondary.js';
import SvgUserIcon from './svgs/UserIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var userIcon = (props => useIcon(SvgUserIcon, SvgUserIconSecondary, props));

export { userIcon as default };
